import { withFormsy } from 'formsy-react'
import React from 'react'
import PreviewVoucher from './PreviewVoucher'

const PreviewVoucherFormsy = (props) => {
  const { setValue, ...rest } = props
  return <PreviewVoucher {...rest} onChange={setValue} />
}

export default withFormsy(PreviewVoucherFormsy)
